import { CallState, MyTripsModalTypes } from "@hopper-b2b/types";
import {
  ActionLink,
  DesktopPopupModal,
  IconComponent,
  IconName,
  MobilePopoverCard,
} from "@hopper-b2b/ui";
import clsx from "clsx";

import { ChangeEmailModalContent } from "./components/ChangeEmailModalContent";
import { StopWatchingModalContent } from "./components/StopWatchingModalContent";

import { WatchItineraryModalConnectorProps } from "./container";
import "./styles.scss";
import { useI18nContext } from "@hopper-b2b/i18n";

interface IWatchItineraryModalProps extends WatchItineraryModalConnectorProps {
  isMobile?: boolean;
}

export const WatchItineraryModal = ({
  isMobile,
  openModal,
  setOpenModal,
  setDeleteWatchCallState,
  setUpdateWatchCallState,
}: IWatchItineraryModalProps) => {
  const { t } = useI18nContext();

  const onClose = () => {
    setOpenModal({ selectedItinerary: null, type: null });
    resetActionState();
  };

  const resetActionState = () => {
    switch (openModal.type) {
      case MyTripsModalTypes.StopWatching:
        return setDeleteWatchCallState(CallState.NotCalled);
      case MyTripsModalTypes.ChangeEmail:
        return setUpdateWatchCallState(CallState.NotCalled);
      default:
        return;
    }
  };

  const getDesktopModalClassName = (): string => {
    const desktopModalClasses = {
      [MyTripsModalTypes.StopWatching]: "stop-watching-modal apac",
      [MyTripsModalTypes.ChangeEmail]: "change-email-modal apac",
    };
    return openModal && openModal.type
      ? desktopModalClasses[openModal.type]
      : "";
  };

  const renderModalContent = () => {
    switch (openModal.type) {
      case MyTripsModalTypes.StopWatching:
        return (
          <StopWatchingModalContent isMobile={isMobile} {...{ onClose }} />
        );
      case MyTripsModalTypes.ChangeEmail:
        return <ChangeEmailModalContent isMobile={isMobile} {...{ onClose }} />;
      default:
        onClose();
        return null;
    }
  };

  const renderDesktopModal = () => (
    <DesktopPopupModal
      className={clsx("my-trips-desktop-modal", getDesktopModalClassName())}
      open={true}
      onClose={onClose}
      invisibleBackdrop={false}
    >
      {renderModalContent()}
    </DesktopPopupModal>
  );

  const renderMobileModal = () => (
    <MobilePopoverCard
      centered
      open
      fullScreen
      contentClassName={clsx("my-trips-mobile-popover-content", "apac")}
      className={clsx("my-trips-mobile-popover-card", "apac")}
      onClose={onClose}
      topRightButton={
        <ActionLink
          className="filter-close-button"
          content={
            <IconComponent
              ariaLabel="Close button icon"
              className={clsx("close-button-icon")}
              name={IconName.Close}
            />
          }
          label={t("close")}
          onClick={onClose}
        />
      }
    >
      {renderModalContent()}
    </MobilePopoverCard>
  );

  return openModal.selectedItinerary
    ? isMobile
      ? renderMobileModal()
      : renderDesktopModal()
    : null;
};
